import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Hubspot from '../../Admin/Hubspot';
import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  Content,
  Img,
  BottomContent,
} from './styles';

function Hero({ data }) {
  if (!data) return null;
  // * This is prismic mapped data
  // * heading {richText} data that makes up the title of the section
  // * subheading {richText} data that makes up the title of the section
  // * bannerCTAText {string} innerText for the CTA
  // * bannerCTA {obj} contains url for CTA
  // * formId {string} to check if the hubspot form should display or not
  // * foregroundImage {obj} the data for the main image that is displayed
  // * backgroundImage {obj} the data for the bg cirlce image (optional)
  // * textWidthBool {bool} Default is true, 50% widths is false
  // * circleAlignment {string} can be Top, Right, Bottom
  const {
    headingHtml,
    subheadingHtml,
    bannerCTAText,
    bannerCTA: { url: href },
    foregroundImage: { altTag },
    imageForegroundSharp,
    imageBackgroundSharp,
    imageMobileBGSharp,
    circleAlignment,
    textWidthBool,
    ctaType,
    gridImageAlignment,
    formId,
    ariaLabel,
    queryString,
    colourOverrideBackground,
    bannerCTATextSecondary,
    bannerCTASecondary,
    ctaTypeSecondary,
    ariaLabelSecondary,
    textUnderCTAHtml,
    heroHeadingColourOverride,
    heroSubheadingColourOverride,
    lang,
  } = data;
  const circlePosition = circleAlignment ? circleAlignment.toLowerCase() : null;

  /* Lifecycle function that injects prefinery popup when using the prefinery cta, on component mount for the first time */
  useEffect(() => {
    if (ctaType === 'prefinery' && !document.getElementById('prefinery_js')) {
      // script tag with code inside
      const prefineryScript = document.createElement('script');
      prefineryScript.text = `{prefinery=window.prefinery||function()
    {(window.prefinery.q = window.prefinery.q || []).push(arguments)};
      document.body.appendChild(prefineryScript)}`;

      // script tag with js to load from url
      const prefineryJs = document.createElement('script');
      prefineryJs.src = 'https://widget.prefinery.com/widget/v2/pp6us4ef.js';
      prefineryJs.id = 'prefinery_js';
      document.body.appendChild(prefineryJs);

      // script tag to close prefinery modal by clicking outside of it, provided by prefinery team and modified to work
      const prefineryClose = document.createElement('script');
      prefineryClose.text = `document.addEventListener("click", (evt) => {
                    const popupModal = document.getElementById("prefinery_popup");
                    const popupOverlay = document.getElementById("prefinery_overlay");
                    let targetElement = evt.target;
                
                    do {
                        if (targetElement == popupModal) {
                            return;
                        }
                        targetElement = targetElement.parentNode;
                    } while (targetElement);
                    if(popupOverlay){
                      popupOverlay.style.display = "none";
                    }
                });`;
      document.body.appendChild(prefineryClose);
    }
  }, []);

  return (
    <Wrapper id="hero" colourOverrideBackground={colourOverrideBackground}>
      <StyledContainer
        className={[
          'auto-margin',
          `${circlePosition}-circle`,
          !textWidthBool && 'reduced-width',
          gridImageAlignment,
        ]}
        background={
          imageBackgroundSharp ? imageBackgroundSharp.publicURL : null
        }
        img={imageForegroundSharp || null}
        mobileImg={imageMobileBGSharp ? imageMobileBGSharp.publicURL : null}
      >
        {/* Todo replace prodigy sans font with colour override instead of conditional fix */}
        <Content
          colourOverrideBackground={colourOverrideBackground}
          heroHeadingColourOverride={heroHeadingColourOverride}
          heroSubheadingColourOverride={heroSubheadingColourOverride}
        >
          {ReactHtmlParser(headingHtml)}
          {ReactHtmlParser(subheadingHtml)}
          {formId ? (
            <Hubspot
              uuid={formId}
              data={bannerCTAText}
              className={`${ctaType} auto-size`}
            />
          ) : (
            <Link
              className={`${
                ctaType === 'prefinery'
                  ? 'solid-on-dark-bg prefinery-form-cta'
                  : ctaType
              }`}
              to={href}
              ariaLabel={ariaLabel}
              queryString={queryString}
              lang={lang}
            >
              {bannerCTAText}
            </Link>
          )}
          {bannerCTASecondary && bannerCTASecondary.url && (
            <Link
              className={`${ctaTypeSecondary}`}
              to={bannerCTASecondary.url}
              ariaLabel={ariaLabelSecondary}
              lang={lang}
            >
              {bannerCTATextSecondary}
            </Link>
          )}
          <BottomContent className="bottom">
            {ReactHtmlParser(textUnderCTAHtml)}
          </BottomContent>
        </Content>
        {imageForegroundSharp && (
          <Img src={imageForegroundSharp} alt={altTag} />
        )}
      </StyledContainer>
    </Wrapper>
  );
}

Hero.propTypes = {
  data: PropTypes.shape().isRequired,
};

Hero.defaultProps = {};

export default Hero;
